// extracted by mini-css-extract-plugin
export default {"categoryouter":"HomeCategory_categoryouter__Sk3pH","categorySlider":"HomeCategory_categorySlider__nQjuv","productimg":"HomeCategory_productimg__RJPhU"};